import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";
import { TYPE_LEAVE } from "./getReasonLeave";

interface InitialState {
  status?: ReduxStateType;
  data: {
    id: string;
    date: string;
    reason: string;
    type: TYPE_LEAVE | "";
    explainAllow: TYPE_LEAVE | null;
  };
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: {
    id: "",
    date: "",
    reason: "",
    type: "",
    explainAllow: null,
  },
};

const handleSendFeedbackSlice = createSlice({
  name: "handleRequestSlice",
  initialState,
  reducers: {
    setupFeedback: (state, action) => {
      state.data = { ...state.data, ...action.payload };
    },
    handleSendFeedbackStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    handleSendFeedbackSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
    },
    handleSendFeedbackFailed: (state, action) => {
      state = {
        ...initialState,
      };
    },
    handleResetDataFeedback: (state) => {
      state.status = ReduxStateType.INIT;
      state.data = {
        id: "",
        date: "",
        reason: "",
        type: "",
        explainAllow: null,
      };
    },
  },
});

export const {
  setupFeedback,
  handleSendFeedbackStart,
  handleSendFeedbackSuccess,
  handleSendFeedbackFailed,
  handleResetDataFeedback,
} = handleSendFeedbackSlice.actions;

export default handleSendFeedbackSlice.reducer;
